module.exports = __webpack_public_path__ + "img/p2-2.89c3ab3c.png";